var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 36,
    viewBox: "0 0 53 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5828 15.4163L37.5894 11.2183H37.4581H37.3269L23.3335 15.4163C23.1585 15.46 23.0274 15.635 23.0274 15.8536C23.0274 16.0723 23.1587 16.2035 23.3335 16.2909L37.3269 20.489C37.4143 20.5327 37.5018 20.5327 37.5892 20.489L51.5826 16.2909C51.7576 16.2472 51.8887 16.0723 51.8887 15.8536C51.8888 15.635 51.7576 15.46 51.5828 15.4163Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8916 15.6037V27.8439L37.5313 23.3224V11.1161L51.8916 15.6037Z",
    fill: "#00359F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5312 11.2957V23.502L22.9915 27.8101V15.4243L37.5312 11.2957Z",
    fill: "#00B2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5828 27.5511L37.5894 23.3531H37.4581H37.3269L23.3335 27.5511C23.1585 27.5948 23.0274 27.7698 23.0274 27.9884C23.0274 28.2071 23.1587 28.3383 23.3335 28.4257L37.3269 32.6237C37.4143 32.6674 37.5018 32.6674 37.5892 32.6237L51.5826 28.4257C51.7576 28.382 51.8887 28.2071 51.8887 27.9884C51.8888 27.7698 51.7576 27.5948 51.5828 27.5511Z",
    fill: "#0055FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.596 11.1392L37.4582 6.98489L51.3204 11.1392C51.5391 11.2266 51.8014 11.0955 51.8451 10.8331C51.9325 10.6145 51.8014 10.3521 51.5391 10.3084L37.5457 6.11043H37.4144H37.2832L23.2898 10.3084C23.0711 10.3958 22.9399 10.6145 22.9837 10.8331C23.115 11.0516 23.3774 11.1829 23.596 11.1392Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.596 10.6263L37.4582 6.47201L51.3204 10.6263C51.5391 10.7137 51.8014 10.5826 51.8451 10.3202C51.9325 10.1016 51.8014 9.83926 51.5391 9.79557L37.5457 5.59755H37.4144H37.2832L23.2898 9.79557C23.0711 9.88297 22.9399 10.1016 22.9837 10.3202C23.115 10.5388 23.3774 10.67 23.596 10.6263Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5952 5.54182L37.4574 1.38754L51.3196 5.54182C51.5382 5.62922 51.8006 5.49812 51.8443 5.23577C51.8879 4.97343 51.8006 4.75479 51.5382 4.7111L37.5448 0.51308H37.4136H37.2823L23.2889 4.7111C23.0703 4.7985 22.939 5.01714 22.9829 5.23577C23.0267 5.45441 23.3766 5.62938 23.5953 5.54182H23.5952Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5952 5.02876L37.4574 0.874474L51.3196 5.02876C51.5382 5.11616 51.8006 4.98506 51.8443 4.72271C51.8879 4.46037 51.8006 4.24173 51.5382 4.19804L37.5448 1.81198e-05H37.4136H37.2823L23.2889 4.19804C23.0703 4.28544 22.939 4.50408 22.9829 4.72271C23.0267 4.94135 23.3766 5.11632 23.5953 5.02876H23.5952Z",
    fill: "#666666"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7162,
    cy: 4.76367,
    rx: 0.769565,
    ry: 0.65339,
    transform: "rotate(-15 23.7162 4.76367)",
    fill: "#666666"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.769565,
    cy: 0.672085,
    rx: 0.769565,
    ry: 0.672085,
    transform: "matrix(-0.963755 -0.266789 -0.251054 0.967973 52.1577 4.34381)",
    fill: "#666666"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7162,
    cy: 10.4072,
    rx: 0.769565,
    ry: 0.65339,
    transform: "rotate(-15 23.7162 10.4072)",
    fill: "#666666"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.769565,
    cy: 0.672085,
    rx: 0.769565,
    ry: 0.672085,
    transform: "matrix(-0.963755 -0.266789 -0.251054 0.967973 52.1577 9.98749)",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5448 23.6118L10.4896 20.5952H10.3953H10.301L0.24584 23.6118C0.120129 23.6432 0.0259247 23.7689 0.0259247 23.926C0.0259247 24.0831 0.120234 24.1774 0.24584 24.2402L10.301 27.2568C10.3638 27.2882 10.4267 27.2882 10.4895 27.2568L20.5447 24.2402C20.6704 24.2088 20.7646 24.0831 20.7646 23.926C20.7648 23.7689 20.6704 23.6432 20.5448 23.6118Z",
    fill: "#D9D9D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7666 23.7465V32.5419L10.4478 29.2928L10.4478 20.5218L20.7666 23.7465Z",
    fill: "#00359F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4478 20.6509L10.4478 29.4219L-6.48499e-05 32.5175L-6.48499e-05 23.6175L10.4478 20.6509Z",
    fill: "#00B2FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5448 32.3314L10.4896 29.3149H10.3953H10.301L0.24584 32.3314C0.120129 32.3628 0.0259247 32.4886 0.0259247 32.6457C0.0259247 32.8028 0.120234 32.8971 0.24584 32.9599L10.301 35.9764C10.3638 36.0079 10.4267 36.0079 10.4895 35.9764L20.5447 32.9599C20.6704 32.9285 20.7646 32.8028 20.7646 32.6457C20.7648 32.4886 20.6704 32.3628 20.5448 32.3314Z",
    fill: "#0055FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/WorkspaceIcon.e7a880ad64c946a935507699f254d124.svg";
export { ForwardRef as ReactComponent };